import { render, staticRenderFns } from "./LocationSublocationTable.vue?vue&type=template&id=724b80d0&"
import script from "./LocationSublocationTable.vue?vue&type=script&lang=js&"
export * from "./LocationSublocationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports